import React, { Component } from 'react'
import { Box, Flex, Button, Text } from 'rebass'
import styled from 'styled-components'

import Title from '../components/Title'
import media from '../components/Media'
import Hide from '../components/Hide'
import TeganExcerpt from '../components/TeganExcerpt'
import SaraExcerpt from '../components/SaraExcerpt'

const BookSection = styled(Flex)`
  flex-direction: column;
  flex: ${props => (props.expanded ? '1 0' : '0 0 75px')};
  position: relative;
  overflow-y: scroll;

  button {
    border-radius: 0;
    width: 100%;
    padding: ${props => props.theme.space[3]}px
      ${props => props.theme.space[4]}px;
    position: ${props => (props.expanded ? 'relative' : 'absolute')};
    text-align: left;
    top: 0;
    left: 0;
    height: ${props => (props.expanded ? 'auto' : '100%')};

    &:focus {
      outline: 0;
    }
  }

  .button-text {
    position: ${props => (props.expanded ? 'relative' : 'absolute')};
    font-size: ${props => (props.expanded ? ' 48px' : '20px')};
    top: ${props => (props.expanded ? 0 : '20px')};
    left: 0;
    right: 0;
    transform: rotate(${props => (props.expanded ? '0deg' : '-90deg')});
    height: ${props => (props.expanded ? 'auto' : '75px')};
    display: ${props => (props.expanded ? 'block' : 'flex')};
    letter-spacing: 1.43px;
    font-family: ${props => props.theme.fonts.sans};
    text-transform: uppercase;
    align-items: center;
    justify-content: center;
  }

  ${media.desktop`
    flex: 1;
    width: 50%;
  `}
`

const TextWrap = styled(Box)`
  display: ${props => (props.expanded ? 'block' : 'none')};

  ${media.desktop`
    display: block;
  `}
`

class BookPreview extends Component {
  state = {
    openSection: 'tegan',
  }

  setOpenSection = name => {
    this.setState({
      openSection: name,
    })
  }

  render() {
    const { openSection } = this.state
    return (
      <Flex css={{ height: 600, overflowX: 'hidden' }}>
        <BookSection
          color="yellow"
          bg="black"
          expanded={openSection === 'tegan'}
        >
          <Hide breakpoints={[1]}>
            <Button
              bg="transparent"
              onClick={() => this.setOpenSection('tegan')}
            >
              <Text color="yellow" className="button-text">
                Tegan
              </Text>
            </Button>
          </Hide>
          <Hide breakpoints={[0]}>
            <Box px={6} pt={12} pb={4}>
              <Title>Tegan</Title>
            </Box>
          </Hide>
          <TextWrap expanded={openSection === 'tegan'} px={[4, 6]} pb={24}>
            <Box>
              <Text
                fontSize={3}
                mb={4}
                css={{ textTransform: 'uppercase', letterSpacing: 1.43 }}
              >
                Welcome to High School
              </Text>
              <TeganExcerpt />
            </Box>
          </TextWrap>
        </BookSection>
        <BookSection
          color="black"
          bg="yellow"
          expanded={openSection === 'sara'}
        >
          <Hide breakpoints={[1, 2]}>
            <Button
              bg="transparent"
              color="black"
              onClick={() => this.setOpenSection('sara')}
            >
              <Text className="button-text">Sara</Text>
            </Button>
          </Hide>
          <Hide breakpoints={[0]}>
            <Box px={6} pt={12} pb={4}>
              <Title>Sara</Title>
            </Box>
          </Hide>
          <TextWrap expanded={openSection === 'sara'} px={[4, 6]} pb={24}>
            <Text
              fontSize={3}
              mb={4}
              css={{ textTransform: 'uppercase', letterSpacing: 1.43 }}
            >
              NAOMI
            </Text>
            <SaraExcerpt />
          </TextWrap>
        </BookSection>
      </Flex>
    )
  }
}

export default BookPreview
